module.exports = __webpack_public_path__ + "static/forecast/windstock/strong-58f6212ae5a3c4544e88d1d3626770ec.svg";